import React from 'react';
import { useDrop } from 'react-dnd';
import { PlayerName } from 'models/baseRunners/PlayerName';
import RemovePlayerContainer from './RemovePlayerContainer';
import { RemovePlayerItem, RemovePlayerWrapper } from './RemovePlayerStyles';

export interface IProps {
  accept: string[];
  onDrop: (item: PlayerName) => void;
}

const RemovePlayer: React.FC<IProps> = (props) => {
  const { accept, onDrop } = props;

  const [{ overDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
      overDrop: monitor.isOver(),
    }),
  });

  return (
    <RemovePlayerWrapper>
      <RemovePlayerItem ref={drop}>
        <RemovePlayerContainer overDrop={overDrop} />
      </RemovePlayerItem>
    </RemovePlayerWrapper>
  );
};

export default RemovePlayer;
